import './FileItem.css';

import React, { Fragment } from 'react';

import Checkbox from '../../elements/Checkbox';
import PropTypes from 'prop-types';
import cx from 'classnames';
import fileIcon from './assets/icon-file.svg';
import fileIconSelected from './assets/icon-file-selected.svg';
import folderMinus from './assets/icon-folder-minus.svg';
import folderPlus from './assets/icon-folder-plus.svg';

const fileItemPadding = 15;

const getIcon = ({ isFile, project, file = {} }) => {
  if (isFile) {
    return project.selectedFile && project.selectedFile.fileId === file.fileId
      ? fileIconSelected
      : fileIcon;
  }
  if (file.open) {
    return folderMinus;
  }
  return folderPlus;
};

const FileItem = ({
  file,
  isFile = !file.folder,
  select,
  toggle,
  project,
  readOnly,
  level = 0
}) =>
  file ? (
    <Fragment>
      <div
        className={cx('file-item', {
          file: isFile,
          selected:
            project.selectedFile && project.selectedFile.fileId === file.fileId
        })}
        style={{
          paddingLeft:
            level === 0
              ? `${fileItemPadding}px`
              : `${(level + 1) * fileItemPadding}px`
        }}
      >
        <div className="file-name">
          <img
            onClick={e => toggle(project, file)}
            alt=""
            src={getIcon({ isFile, project, file })}
          />
          {!readOnly && (
            <Checkbox
              onChange={e => select(project, file)}
              checked={file.selected}
            />
          )}
          <span className="file-title" onClick={e => toggle(project, file)}>
            {file.fileName}
          </span>
        </div>
      </div>
      {file.folder && file.open
        ? file.children.map(child => (
            <FileItem
              key={`${child.fileId}-${child.fileName}`}
              file={child}
              toggle={toggle}
              select={select}
              project={project}
              level={level + 1}
              readOnly={readOnly}
            />
          ))
        : null}
    </Fragment>
  ) : null;

FileItem.propTypes = {
  file: PropTypes.object.isRequired,
  isFile: PropTypes.bool,
  select: PropTypes.func,
  toggle: PropTypes.func,
  project: PropTypes.object.isRequired,
  readOnly: PropTypes.bool,
  level: PropTypes.number
};

FileItem.defaultProps = {
  select: () => {},
  toggle: () => {}
};

export default FileItem;



// WEBPACK FOOTER //
// ./src/components/elements/FileItem/index.js